








































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Contact } from '@/types';

@Component
export default class NewContactModal extends Vue {
    @Prop({ default: 'New Contact'}) readonly title!: string;
    @Prop({
       default: {
           name: '',
           email: '',
           phone: '',
       },
   }) readonly contact!: Contact;

    contactData: Contact = Object.assign({}, this.contact);
    titleData: string = this.title;

    showModal() {
        this.contactData = Object.assign({}, this.contact);
        if (this.contactData.id) {
            this.titleData = 'Edit Contact';
        } else {
            this.titleData = 'New Contact';
        }
        (this.$refs.modal as any).show();
    }

    saveModal() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                (this.$refs.modal as any).hide();
                this.save();
            }
        });
    }

    @Emit()
    save() {
        return this.contactData;
    }

    validateField(name: string) {
        if (this.veeFields[name] && (this.veeFields[name].dirty || this.veeFields[name].validated)) {
          return !this.errors.has(name);
        }
        return null;
    }
}
